export default __webpack_public_path__ + "static/DSC_0305-8e9e764b45137d4c439d175779b32537.jpg";